cb.define([], function () {
  var AP_ap_aurumprice_VM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
		var self = this;
		var detailModel = viewmodel.get("aurumPriceDetail");
		var storeModel = viewmodel.get("aurumPriceStore");
		var dataSources = detailModel.getEditRowModel().get('cAurumType').getState('dataSource');
		if(detailModel) {
			detailModel.on('afterSelect', function (data){
				var mode = viewmodel.getParams().mode;
				var priceModel = viewmodel.get('aurumPriceDetail')
				var dataSource = dataSources;
				var datas = viewmodel.get('aurumPriceDetail').getRows();
        var rowDatas = [];
        var rowStates = {};
		dataSource.forEach(function(item){
			var type = true;
			datas.forEach(function (item1, index) {
				if(item1.cAurumType == item.value && item1.cAurumType != undefined && index != data[0])
					type = false;
			});
			if(type)
			{
				rowDatas.push({
					text:item.text,
					value:item.value
				});
			} else {
            rowStates[item.value]={visible:false};
			}
		});
        // detailModel.getEditRowModel().get('cAurumType').setDataSource(rowDatas);
        detailModel.getEditRowModel().get('cAurumType').setState('rowStates', rowStates);
			});

			detailModel.on('afterCellValueChange', function(data) {
				var cellName =  data.cellName;
				var childrenField = data.childrenField;
				if(cellName == 'cPriceDimension' && childrenField == 'aurumPriceDetail'){
					if(data.value == undefined)
						return;
					var value = data.value.value;
					var rows  = data.rowIndex;
					if(value === '2')
					{
						viewmodel.get("aurumPriceDetail").setCellValue(rows,"cRealAurumType",1);
						viewmodel.get("aurumPriceDetail").setCellValue(rows,"fBrandPrice",0);
					}

				}
				if(cellName == 'iRecoveryLossRate' && childrenField == 'aurumPriceDetail'){
					if(data.value == undefined)
						return;
					var value = data.value;
					var rows  = data.rowIndex;
					if(!isNaN(value))
					{
						if(Number(value) < 0 || Number(value) >= 100 )
						{
							viewmodel.get("aurumPriceDetail").setCellValue(rows,"iRecoveryLossRate",data.oldValue);
							cb.utils.alert('回收损耗率值范围(0-100之内包含0)');
						}

					}

				}

			});
			detailModel.on('rowColChange', function(args) {
				var rows  = args.value.rowIndex;
				var currentRow = detailModel.getRow(rows);
				if(args.value.columnKey == 'cAurumType')
				{
					var datastate = detailModel.getRowDataState(rows);
					var sta = viewmodel.get("status").getValue();
					if(datastate != 'Insert' && sta == 1)
						return false;
				}
				if(args.value.columnKey == 'fBrandPrice')
				{
					var sta = detailModel.getRowsByIndexes(rows)[0];
					if(sta === undefined)return true;
					var dimen = sta.cPriceDimension;
					if(dimen === undefined) return true;
					if(dimen === '2')
						return false;

				}
			});
		}
		if(storeModel)
		{
			//过滤掉列表存在的数据
			storeModel.on('beforeBrowse', function (data) {
				if(data != undefined)
				{
					var rows = storeModel.getRows();
					var id = [];
					rows.forEach(function (item, index) {
						if (data.rowIndex === index) return;
						if (item.iStoreid_name === undefined) return;
						id.push(item.iStoreid);
					})
					switch (data.cellName) {
						case "iStoreid_name":
						var condition = { "isExtend": true, simpleVOs: [] };
						condition.simpleVOs.push({
						field: 'id',
						op: 'nin',
						value1: id
					  });
					  data.context.setFilter(condition);
					  break;
					}
				}
			});
			//已经选择的门店不能再次选择
			storeModel.on('beforeCellValueChange', function (data) {
			  if (data.cellName === 'iStoreid_name') {

				var rows = storeModel.getRows();
				var storeid = [];
				rows.forEach(function (item, index) {
				  if (data.rowIndex === index) return;
				  storeid.push(item.iStoreid);
				})
				if(data.value != undefined)
				{
					if (storeid.indexOf(data.value.id) > -1)
						return false;
				}
			  }
			});
			storeModel.on('rowColChange', function(args) {
				var rows  = args.value.rowIndex;
				var currentRow = storeModel.getRow(rows);
				if(args.value.columnKey == 'iStoreid_name')
				{
					var datastate = storeModel.getRowDataState(rows);
					var sta = viewmodel.get("status").getValue();
					if(datastate != 'Insert' && sta == 1 )
					{
						return false;
					}
				}
			});
		}
		viewmodel.on('beforeSave', function(args) {

			return aurmdetail(args);

		});

		viewmodel.on('beforeSaveandadd', function(args) {

			return aurmdetail(args);
		});

		var aurmdetail = function(args){
			var aurumDetail = viewmodel.get('aurumPriceDetail');
			var rows = aurumDetail.getRows();
			var type = false;
			var tpl = false;
			rows.forEach(function (item, index) {

				if (item.cPriceDimension == "2" && item.cRealAurumType == undefined)
				{
					type = true;
				}else if (item.cPriceDimension == "1" && Number(item.fBrandPrice) <= 0)
				{
					tpl = true;
				}

			})
			if(!tpl)
			{
				return true;
			}else{
				cb.utils.alert('取价维度为牌面价时，牌面价值必须大于0');
				return false;
			}
			if(!type)
			{
				return true;
			}else{
				cb.utils.alert('取价维度为实时金价时，实时金价类型不能为空');
				return false;
			}
		};

    },

  }
  try {
    module.exports = AP_ap_aurumprice_VM_Extend;
  } catch (error) {

  }
  return AP_ap_aurumprice_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AP/AP_ap_aurumprice_VM.Extend.js